import _ from 'underscore';
import { Decorator } from './decorator';

const ALLOWED_PAGE_SIZES = [20, 50, 100, 200];

export class PaginationDecorator extends Decorator {
  /**
   * Creates an instance of PaginationDecorator.
   * @param {any} {
   *     featureName: The name of feature, such as 'PerformanceGrid',
   *     defaultPageSize: The default page size if none found,
   *     deps: Legacy deps
   *     deps.fetchPaginationConfig: from 'component/bingads-grid/service/fetch-pagination',
   *   }
   * @memberof PaginationDecorator
   */
  constructor({ featureName, defaultPageSize, deps }) {
    super({ name: 'pagination', deps, expectedDeps: ['fetchPaginationConfig'] });

    this.fetchPaginationConfig = deps.fetchPaginationConfig;

    this.featureName = featureName;
    this.defaultPageSize = defaultPageSize || _.first(ALLOWED_PAGE_SIZES);
  }

  getValueAsync() {
    return this.fetchPaginationConfig(this.featureName, this.defaultPageSize);
  }

  buildQuery(queryParams, { pageSize, pageNumber }) {
    if (!_.contains(ALLOWED_PAGE_SIZES, pageSize)) {
      /* eslint-disable no-param-reassign */
      pageSize = _.first(ALLOWED_PAGE_SIZES);
    }

    const transformedQueryParams = _.extend({}, queryParams, {
      take: pageSize,
      skip: pageNumber * pageSize,
    });

    return transformedQueryParams;
  }
}
